import $ from 'jquery';
import { initClickTracking } from './click-tracking';
import config from './util/config';
import renderTemplate from './util/template';
import svgTemplate from './views/svg.tpl.html';

let isExternalLinkFunc;

const componentsSvg = `${config.svgPath}component-sprite.svg`;
const icons = {
  action: 'chevron-circle-right',
  external: 'external-link',
  secure: 'lock'
};

// types external, secure, action
const addLinkSVG = (link, type) => {
  if (link.find(`svg.${type}`).length === 0 && !link.hasClass('btn')) {
    if (link.find(`svg:not(.${type})`).length === 0) {
      const svg = renderTemplate(svgTemplate, {
        cls: type,
        svgSpritePath: componentsSvg,
        icon: icons[type]
      });

      // TODO: is this reliable? Check if text-nowrap already exists?
      const words = link.html().split(/\s+/);
      const lastWord = words.pop();
      const firstPart = words.join(' ');

      link.html(`${firstPart} <span class="text-md-nowrap">${lastWord}${svg}</span>`);
    }
  }
};

// eslint-disable-next-line no-unused-vars
export const isExternal = (link, href, hostname) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  $.trim(link.text()).length // is not an icon or image
  && href.includes('//'); // not internal

// Security concern: https://mathiasbynens.github.io/rel-noopener/ for target="_blank"
const sanatizeTargetBlank = (rel) => {
  const parts = new Set((rel || '').split());
  parts.add('noopener');
  parts.add('noreferrer');
  return [...parts].join(' ').trim();
};

export const initActionLinks = () => {
  $('a.link-action').each((index, el) => addLinkSVG($(el), 'action'));
};

export const initBlankLinks = () => {
  $('[target=_blank]').each((index, el) => {
    el = $(el);
    el.attr('target', '_blank');
    el.attr('rel', sanatizeTargetBlank(el.attr('rel')));
  });
};

export const initExternalLinks = (addIcon = true) => {
  if (!isExternalLinkFunc) {
    isExternalLinkFunc = isExternal;
  }

  $('a:not(.link-external)').each((index, el) => {
    el = $(el);
    const href = el.attr('href') || '';
    const { hostname } = el.get(0);
    if (isExternalLinkFunc(el, href, hostname)) {
      el.addClass('link-external');
    }
  });

  $('a.link-external').each((index, el) => {
    el = $(el);
    el.attr('target', '_blank');
    if (addIcon) {
      addLinkSVG(el, 'external');
    }
  });

  initBlankLinks();
};

export const initSecureLinks = () => {
  $('a.link-secure').each((index, el) => addLinkSVG($(el), 'secure'));
};

export const setExternalLinkChecker = (isExternalFunc) => {
  isExternalLinkFunc = isExternalFunc;
};

export const initPdfLinks = () => {
  $('a[href*=".pdf"]').each((index, el) => {
    if (el.text !== '' && el.text.indexOf('[PDF]') < 0) {
      $(el).append(' [PDF]');
    }
  });
};

export default () => {
  initPdfLinks();
  initActionLinks();
  initExternalLinks();
  initSecureLinks();
  initClickTracking();
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/links.js